export { Login } from "./Login";
export { default as Registro } from "./Register";
